import styled from 'styled-components/macro'
import { mobile } from '../theme'
import { swing } from './menu/MainMenuEntry'

const Boat = styled.img.attrs({
  src: '/img/boat.svg',
  height: '70px'
})`
  animation: ${swing} 2s ease-in-out;
  animation-fill-mode: forwards;
  user-select: none;
  position: absolute;
  bottom: -10px;
  right: 40px;

  :hover {
    animation: ${swing} 2s ease-in-out infinite;
  }

  ${mobile`
    display: none;
  `}
`

export default Boat
